export const RESERVED_CUTOM_ATTRIBUTE_KEYS = [
    'id',
    'phone',
    'email',
    'first_name',
    'last_name',
    'time_zone',
    'entry_channel',
    'membership_status',
    'lifecycle_status',
    'entry_point',
    'date_added',
    'tags',
    'marketing_subscription_status',
    'transactional_subscription_status',
];
